import Select from "../../layout/components/Select"
import { useEffect, useState } from 'react';
import {getList} from "../../common/BackendProvider.jsx";
import { toast } from 'react-toastify';

export const SearchBar = ({setSector, setIndustry, setRegion, setSize}) => {
    const[sectors, setSectors] = useState([])
    const[industries, setIndustries] = useState([])
    const[regions, setRegions] = useState([])
    const sizeOptions = [
        {id: 0, name: "All market sizes"},
        {id: 1, name: "Small"},
        {id: 2, name: "Medium"},
        {id: 3, name: "Large"}
    ]
    useEffect(() => {
        getList("sectors").then((response) => {
            setSectors([{ id: 0, name: "All sectors" }, ...(response.data.sectors || [])])
        }).catch(
            (e) => {
                toast.error("Error while loading sectors", {})
            }
        )
        getList("industries").then((response) => {
            setIndustries([{ id: 0, name: "All industries" }, ...(response.data.industries || [])])
        }).catch(
            (e) => {
                toast.error("Error while loading industries", {})
            }
        )
        getList("regions").then((response) => {
            setRegions([{ id: 0, name: "All regions" }, ...(response.data.regions || [])])
        }).catch(
            (e) => {
                toast.error("Error while loading regions", {})
            }
        )
    },[])
    const handleChange = (value, area) => {
        if (area === "sector") {
            setSector(value)
        } else if (area === "industry") {
            setIndustry(value)
        } else if (area === "region") {
            setRegion(value)
        } else if (area === "size") {
            setSize(value)
        }
    }
    return(
        <div>
            <div className="mb-4 flex flex-col gap-1">
                <div className="text-sm font-bold text-slate-950">Filter universe</div>
                <div className="text-xs font-semibold text-slate-500">Narrow the company list by classification and market profile.</div>
            </div>
            <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
                <div>
                    <Select label="Sector" options={sectors} onChange={(id)=>{handleChange(id, "sector")}}/>
                </div>
                <div>
                    <Select label="Industry" options={industries} onChange={(id)=>{handleChange(id, "industry")}}/>
                </div>
                <div>
                    <Select label="Region" options={regions} onChange={(id)=>{handleChange(id, "region")}}/>
                </div>
                <div>
                    <Select label="Market size" options={sizeOptions} onChange={(id)=>{handleChange(id, "size")}}/>
                </div>
            </div>
        </div>
    )
}
